<template>
  <ContainerComponent>
    <div class="container">
      <h1>{{ section.name }}</h1>
      <div class="subtitle">
        <i v-if="isCustomSelection" class="icon icon-crown"></i>
        {{ customSelectionName }}
      </div>
      <!-- <div class="image-container">
        <div class="placeholder" v-if="buildNumber">
          <i v-show="loading" class="icon loading" />
          <span v-for="url in imagesUrls" :key="url">
            <InlineSvg ref="productFamily" :src="url" @loaded="picLoaded" />
          </span>
        </div>
      </div> -->
      <div class="image-container">
        <FamilyViewerComponent :selectedFamily="section.name" :customProducts="customProducts" @showSelectedProduct="showProduct" />
      </div>
      <div ref="productFamilyFooter" class="bottom-escape">
        <div class="bottom-inner">
          <i
            class="icon icon-arrow-left text-xl clickable"
            @click="goBack($event)"
          />
        </div>
      </div>
    </div>
  </ContainerComponent>
</template>

<script>
import ContainerComponent from '@/components/ContainerComponent';
import InlineSvg from 'vue-inline-svg';
import { DEFAULT_PROJECT } from '@/constants';
import { getStaticUrl } from '@/helpers';
import readIsManaVersionFlag from '@/shared/manaVersionHelper';
import axios from 'axios';
import FamilyViewerComponent from '@/components/FamilyViewerComponent.vue';
import StaticUrlService from '@/services/staticUrlService';

export default {
  components: {
    ContainerComponent,
    InlineSvg,
    FamilyViewerComponent
  },
  props: {
    section: {
      type: Object,
      required: true
    },
    images: { 
      type: Array,
      default: []
    },
    productsId: { 
      type: String,
      default: 'productViewer'
    }
  },
  data() {
    return {
      loading: true,
      buildNumber: 0,
      imagesUrls: [],
      customProducts: []
    };
  },
  created() {
    this.customProducts = this.$store.getters.checkedProducts(this.section.name);
  },
  async mounted() {
    const fullStaticUrl = await StaticUrlService.getFullStaticUrl(null, this.$route.name);
    axios.get(`${fullStaticUrl}productData.json?` + Date.now()).then(result => {
      this.$store.commit(
        'radios',
        result.data.filter(x => x.isMana == readIsManaVersionFlag())
      );
    });
    axios.get(`${fullStaticUrl}assetsConfig.json?` + Date.now()).then(result => {
      this.buildNumber = result.data.buildNumber;
    });
    // await this.loadImagesUrl(this.images);
  },
  watch: {
    images: async function (newImages) {
      await this.loadImagesUrl(newImages);
    }
  },
  computed: {
    isCustomSelection() {
      return this.$store.getters.activeCategories.length;
    },
    checkedProducts() {
      return this.$store.getters
        .checkedProducts(this.section.name)
        .map(productName => productName.replace(/_$/, ''));
    },
    customSelectionName() {
      return this.$store.state.customSelectionName !== DEFAULT_PROJECT.name
        ? this.$store.state.customSelectionName
        : '';
    },
    staticUrl () {
      return getStaticUrl(null, this.$route.name);
    }
  },
  methods: {
    // clickedSelectionBox(e, s) {
    //   e.preventDefault();

    //   const product = this.$store.state.radios
    //     .filter(radio => radio.sectionName === this.section.name)
    //     .find(radio => radio.productId === s.split(' ').join('_'));

    //   this.$router.push({ name: `${this.section.prefix}`, params: { product: product.fileName }  });
    // },
    showProduct(productNameId) {
      const product = this.$store.state.radios
        .filter(radio => radio.sectionName === this.section.name)
        .find(radio => radio.productId === productNameId.split(' ').join('_'));

      this.$router.push({ name: `${this.section.prefix}`, params: { product: product.fileName }  });
    },
    // picLoaded() {
    //   this.loading = false;
    //   if (this.$refs.productFamily && this.$refs.productFamily.length) {
    //     this.$refs.productFamily.forEach(el => {
    //       if(!el?.$el?.querySelectorAll) {
    //         return;
    //       }

    //       const selectionBoxes = el.$el.querySelectorAll('polygon').length === 0 
    //         ? el.$el.querySelectorAll('g > path[fill="red"]') 
    //         : el.$el.querySelectorAll('polygon');

    //       if (el.$el.querySelectorAll('polygon').length === 0) {
    //         selectionBoxes.forEach(node => {
    //           node.classList.add('polygon');
    //         })
    //       }

    //       if (!this.isCustomSelection) {
    //         this.showAllProducts(selectionBoxes);
    //       } else {
    //         this.showSelectedProducts(selectionBoxes);
    //       }
    //     })
    //   }
    // },
    goBack() {
      this.$router.push({ name: 'radio' });
    },

    // makeProductVisible(box) {
    //   box.classList.add('VisibleBox');
    //   box.onclick = e => {
    //     this.clickedSelectionBox(e, box.parentNode?.id);
    //   }
    // },
    // showAllProducts(selectionBoxes) {
    //   selectionBoxes.forEach(box => {
    //     this.makeProductVisible(box)
    //   });
    // },
    // showSelectedProducts(selectionBoxes) {
    //   selectionBoxes.forEach(box => {
    //     if (box.parentNode && this.checkedProducts.includes(box.parentNode.id)) {
    //       this.makeProductVisible(box);
    //     } else {
    //       box.style = 'fill-opacity: 1'; 
    //     }
    //   });
    // },
    // async loadImagesUrl(images) {
    //   images.forEach(async (i) => {
    //     var url = await this.getImageUrl(i);
    //     this.imagesUrls.push(url);
    //   })
    // },
    // async getImageUrl(name) {
    //   return await FamilyPreviewApiService.getFamilyUrl(name);
    // }
  }
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '~@/assets/common.less';

.container {
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: @layer1;
  h1 {
    margin: @space-xl @space-xl 0 (@space-xxl + @space-xl);
  }
  .subtitle {
    margin: 0 0 @space-xl (@space-xxl + @space-xl);
    max-width: @proj-name-max-width;
  }
}
.placeholder {
  display: flex;
  justify-content: center;
  height: 100%;
}

.image-container {
  width: 100%;
  height: 100%;
}
svg {
  max-width: 100%;
  height: 100%;
  ::v-deep polygon {
    pointer-events: none;
    cursor: pointer;
    color: #00000000;
    &:hover {
      + line {
        stroke-width: 0px;
      }
    }
    + line {
      stroke-width: 0px;
    }
    fill: #181818;
    opacity: 1;
  }
  ::v-deep .polygon {
    pointer-events: none;
    cursor: pointer;
    color: #00000000;
    &:hover {
      + line {
        stroke-width: 0px;
      }
    }
    + line {
      stroke-width: 0px;
    }
    fill: #181818;
    opacity: 1;
  }
  ::v-deep .VisibleBox {
    pointer-events: auto;
    fill: transparent;
    &:hover {
      + line {
        stroke-width: 5px;
      }
    }
  }
}
.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.bottom-escape {
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-left: @space-xxl;
  padding-right: @space-xl;
  padding-bottom: @space-large;
  .icon-general {
    width: @font-size-lg;
    height: @font-size-lg;
  }
}
</style>
